module.exports = __webpack_public_path__ + "img/network-icon.1302fe85.svg";